module.exports = __webpack_public_path__ + "static/media/the_road_to_react1.9d43124a.md";